import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://www.mareaa.online/cart/53202441404781:1';
export function ProblemSection() {
  return <section className="w-full bg-bg-softer py-16 px-4 md:px-8" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-171">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark mb-6 text-center" data-id="element-172">
            Esto es lo que realmente está manteniendo tu abdomen{' '}
            <span className="text-highlight" data-id="element-173">inflamado</span>
          </h2>

          <div className="space-y-4 mb-8 text-center" data-id="element-174">
            <p className="text-primary-mid" data-id="element-175">No es que comés mucho.</p>
            <p className="text-primary-mid" data-id="element-176">
              No es que te falta fuerza de voluntad.
            </p>
            <p className="text-accent font-semibold text-lg" data-id="element-177">
              👉 Es que la inflamación tiene causas concretas que la mayoría
              ignora… y hasta que no las corregís, nada va a cambiar.
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-secondary-light/20 mb-8" data-id="element-178">
            <p className="font-semibold text-text-dark mb-4" data-id="element-179">
              Cuando empezás a trabajar desde adentro:
            </p>
            <div className="space-y-3" data-id="element-180">
              <p className="flex items-start gap-2 text-primary-mid text-sm" data-id="element-181">
                <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-182">✓</span>
                Tu abdomen empieza a desinflamarse desde los primeros días
              </p>
              <p className="flex items-start gap-2 text-primary-mid text-sm" data-id="element-183">
                <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-184">✓</span>
                Tu digestión mejora y te sentís más liviana
              </p>
              <p className="flex items-start gap-2 text-primary-mid text-sm" data-id="element-185">
                <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-186">✓</span>
                Dejás de sentirte hinchada después de cada comida
              </p>
              <p className="flex items-start gap-2 text-primary-mid text-sm" data-id="element-187">
                <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-188">✓</span>
                Recuperás energía y comodidad en tu propio cuerpo
              </p>
            </div>
            <p className="text-sm text-primary-mid/70 mt-4 font-medium" data-id="element-189">
              Y no… no necesitás pasar hambre ni hacer dietas imposibles.
            </p>
          </div>

          <div className="text-center" data-id="element-190">
            <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold px-10 py-5 rounded-full shadow-lg shadow-accent/25 transition-all duration-300 text-base md:text-lg" data-id="element-191">
              QUIERO EMPEZAR A DESINFLAMARME HOY
              <ArrowRightIcon className="w-5 h-5" data-id="element-192" />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}